module.exports = __webpack_public_path__ + "img/AL.c6df1c9c.svg";